import page from 'page'
import React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withState, lifecycle } from 'recompose'
import { FormattedMessage, injectIntl } from 'react-intl'

import { logOut } from '../store/reducers/auth'
import { fetchingState } from './../helpers/hocs.js'
import { getIsLogged, getLoggedUser } from '../selectors/user.js'
import { getState, getBidHistory, paidIsDone, requestMeet } from '../store/reducers/profile/info'

import MainContainer from './Main'
import SingleList from './LotList/singleList'
import Sidebar from '../components/Profile/Sidebar'
import BidHistory from '../components/Lot/BidHistory'

import Overlay from '../components/Overlay'

import EditForm from '../components/Profile/Edit'
import ClaimForm from '../components/Profile/Claim'
import ReportForm from '../components/Profile/Report'

import {sendViewCard} from './../helpers/tagManager'
import NationalCards from '../components/NationalCards'

const ProfilePage = ({ donations, lots, fixedpricelots, bids = [], totalSum, reportLot, requestMeet, closeReport, setModalState, openReport, modalState, logOut, user, fetching, paidIsDone, intl }) => {
  if (fetching.state) return null
  return (
    <MainContainer
      Sidebar={<Sidebar lots={lots.win || []} fixedpricelots={fixedpricelots || []} totalSum={totalSum} onLinkClick={setModalState} onLogOut={logOut} />}
    >
      {((lots.paid || []).length > 0) && (
        <SingleList
          noTime
          className='Main__top'
          items={lots.paid}
          button={requestMeet}
          btnTitle={intl.formatMessage({id: 'profile.meet'})}
          title={intl.formatMessage({id: 'profile.auctions_won'})}
          listName={'Профиль: Выигранные аукционы'}
        />
      )}

      {((lots.requested || []).length > 0) && (
        <SingleList
          noTime
          className='Main__top'
          items={lots.requested}
          title={intl.formatMessage({id: 'profile.organize_meeting'})}
          listName={'Профиль: Договариваемся о встрече'}
        />
      )}

      {((lots.visited || []).length > 0) && (
        <SingleList
          isComplete
          className='Main__top'
          items={lots.visited}
          button={openReport}
          btnTitle={intl.formatMessage({id: 'profile.tell_about_meeting'})}
          title={intl.formatMessage({id: 'profile.meetings'})}
          listName={'Профиль: Встреча проведена'}
        />
      )}

      {(!bids.length && (!lots.active || !lots.active.length)) &&
        <div className='max-width'>
          <h1 className='Head'>
            <FormattedMessage id='profile.win_meeting' />
          </h1>
          <br />
          <p className='Text bottom-space'>
            <FormattedMessage id='profile.choose_auction' />
          </p>
          <a href='/lots' className='Button Button_black'>
            <FormattedMessage id='profile.see_auctions' />
          </a>
        </div>
      }

      <SingleList items={lots.active || []} title={intl.formatMessage({id: 'profile.active_auctions'})} withPadding listName={'Профиль: Активные аукционы'}/>
      {(bids.length > 0) && <BidHistory items={bids} show={true} title={intl.formatMessage({id: 'profile.bid_history'})} urlPrefix='lots' />}
      <NationalCards classname='profile'/>
      <Overlay isActive={modalState.claim} onClose={setModalState.bind(this, 'claim', false)} klassModifier={"mfc-modal_3"}>
        <ClaimForm onSuccess={setModalState.bind(this, 'claim', false)} />
      </Overlay>

      <Overlay isActive={modalState.edit} onClose={setModalState.bind(this, 'edit', false)}>
        <EditForm />
      </Overlay>

      <Overlay isActive={reportLot} onClose={closeReport}>
        <ReportForm lot={reportLot} onSuccess={paidIsDone} />
      </Overlay>
    </MainContainer>
  )
}

const mapStateToProps = state => ({
  //user: getLoggedUser(state),
  isLogged: getIsLogged(state),
  ...state.profile.info
})
const mapDIspatchToProps = dispatch => bindActionCreators({ getState, getBidHistory, logOut, paidIsDone, requestMeet }, dispatch)
const mergeProps = (state, { paidIsDone, getState, getBidHistory, requestMeet, logOut }, props) => ({
  ...props,
  ...state,
  logOut,
  paidIsDone,
  requestMeet,
  getBidHistory,
  getState: () => props.fetchingWrap(getState.bind(this), 'state')
})

export default injectIntl(compose(
  fetchingState({ multi: true }),
  connect(mapStateToProps, mapDIspatchToProps, mergeProps),
  withState('modalState', 'setModalState', {}),
  withState('reportLot', 'setReportLot', null),
  withHandlers({
    setModalState: ({ setModalState, modalState }) => (name, state, e) => {
      e && e.preventDefault()
      if ([ 'claim', 'edit', 'report' ].indexOf(name) === -1) return
      modalState[name] = state || false
      setModalState(modalState)
    },
    openReport: ({ setModalState, lots, setReportLot }) => (_id, e) => {
      e && e.preventDefault()
      const [ lot ] = (lots.visited || []).filter(el => el._id === _id)
      if (!lot) return

      setReportLot(lot)
    },
    closeReport: ({ setReportLot }) => e => {
      e && e.preventDefault()
      setReportLot(null)
    },
    requestMeet: ({ requestMeet }) => (_id, e) => {
      e && e.preventDefault()
      requestMeet(_id)
    }
  }),
  lifecycle({
    componentWillMount () {
      if (!this.props.isLogged) this.props.on404()
      else {
        this.props.getBidHistory()
        this.props.getState()
      }
    },
    componentWillReceiveProps (np) {
      if (this.props.isLogged && !np.isLogged) page('/')
      if (np && np.lots.paid && np.lots.paid.length > 0 && np.lots.paid != this.props.lots.paid) sendViewCard(np.lots.paid, 'Профиль: Выигранные аукционы')
      if (np && np.lots.requested && np.lots.requested.length > 0 && np.lots.requested != this.props.lots.requested) sendViewCard(np.lots.requested, 'Профиль: Договариваемся о встрече')
      if (np && np.lots.visited && np.lots.visited.length > 0 && np.lots.visited != this.props.lots.visited) sendViewCard(np.lots.visited, 'Профиль: Встреча проведена')
      if (np && np.lots.active && np.lots.active.length > 0 && np.lots.active != this.props.lots.active) sendViewCard(np.lots.active, 'Профиль: Активные аукционы')
      console.log('пропсы пользователя****************************', np)
    }
  })
)(ProfilePage))



// WEBPACK FOOTER //
// ./src/containers/Profile.jsx